export default function ContactDecemberClosedDays() {
    return (
        <p className="closed"><strong>Obs.:</strong> vi har lukket 24.-26., og 31. december samt 1. januar.</p>
    )
}
